<template>
  <v-app-bar :color="returnColor()" fixed dense app elevation="0">
    <loading
      :active="isload"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <img
      src="../../assets/master_logo.png"
      alt="QQPay"
      style="max-height: 60px; max-width: 110px"
    />

    <v-spacer></v-spacer>

    <v-chip color="primary" label>
      <span class="font-weight-bold"
        ><v-icon class="me-1">mdi-account-circle</v-icon>{{ user_email }}</span
      >
    </v-chip>
    <v-chip
      class="ms-2"
      color="white"
      v-if="this.partner_Data && this.partner_Data.partner_name"
      outlined
      label
    >
      <p class="pb-0 mb-0 font-weight-bold">
        {{ this.partner_Data ? this.partner_Data.partner_name : "" }}
      </p>
    </v-chip>
    <v-btn
      depressed
      color="white"
      x-small
      class="ms-2"
      fab
      active-class="primary"
      @click="logoutDialog = true"
      title="Logout"
    >
      <v-icon>mdi-power</v-icon>
    </v-btn>

    <!-- <v-menu left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          icon
          v-bind="attrs"
          v-on="on"
          title="Menu"
          color="white"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group
          color="primary"
          active-class="orange--text text--accent-4"
        >
          <v-list-item
            v-for="(menuItem, idx) in menuList"
            :key="idx"
            link
            :to="menuItem.path"
            class="text-decoration-none"
            :disabled="!menuItem.isActive"
          >
            <v-list-item-title
              ><v-icon>{{ menuItem.icon }}</v-icon>
              {{ menuItem.title }}</v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
        <v-list-item class="border-bottom">
          <v-list-item-content>
            <v-list-item-subtitle class="text-overline"
              >{{ $t("app_version") }}
              <strong>v{{ appVersion }}</strong></v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu> -->

    <!-- <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed 
            icon
            v-bind="attrs"
            v-on="on"
            title="Menu"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item class="border-bottom">
            <v-list-item-content>
              <v-list-item-subtitle class="text-overline">App version: <strong>v{{ appVersion }}</strong></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item-group
            color="primary"
            active-class="orange--text text--accent-4">
            <v-list-item 
              v-for="(menuItem, idx) in menuList"
              :key="idx"
              link 
              :to="menuItem.path" 
              class="text-decoration-none"
              :disabled="!menuItem.isActive"
            >
              <v-list-item-title><v-icon>{{menuItem.icon}}</v-icon> {{menuItem.title}}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu> -->

    <!-- Logout confirmation popup dialog -->
    <v-dialog persistent v-model="logoutDialog" width="500">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0" dense dark>
          <span class="font-weight-bold">Logout</span>
          <v-spacer></v-spacer>
          <v-icon @click="logoutDialog = false">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text class="h5 text-center py-5"
          >Are you sure you want to logout?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="logout">
            <v-icon>mdi-check</v-icon>Yes
          </v-btn>
          <v-btn
            depressed
            color="primary"
            outlined
            @click="logoutDialog = false"
            ><v-icon>mdi-close</v-icon>No</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app-bar>
</template>

<script>
const pjson = require("../../../package.json");
import Loading from "vue-loading-overlay";
import alerts from "@/mixins/alerts";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  name: "NavBar",
  props: {},
  component: {
    Loading,
  },
  data() {
    return {
      appVersion: pjson.version,
      partner_Data: "",
      logoutDialog: false,
      isload: false,
      isMenuClosed: true,
      items: [],
      user_email: "",
      menuList: [
        {
          icon: "mdi-home-outline",
          title: "Home",
          path: "/home",
          isActive: true,
        },
      ],
    };
  },
  watch: {},
  mounted() {
    this.partner_Data = JSON.parse(sessionStorage.getItem("send_partner_data"));
    console.log("appVersion", this.appVersion);
    this.user_email = sessionStorage.getItem("username");
  },

  methods: {
    reloadComponent() {
      this.$emit("reload");
    },
    returnColor() {
      return `#${process.env.VUE_APP_COLOR}`;
    },
    async logout() {
      this.isload = true;
      try {
        const responseData = await userService.Logout();
        this.isload = false;
        if (responseData && responseData.data.status_code === 200) {
          this.showAlertSuccess(responseData.data.message);
          sessionStorage.clear();
          this.isload = false;
          this.$router.push({ name: "Login" });
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        this.isload = false;
        this.showAlertError("Something went wrong please try again later.");
        console.error(e);
      }
    },
    toggleMenu() {
      this.isMenuClosed = !this.isMenuClosed;
      this.$emit("toggleMenu", this.isMenuClosed);
    },
  },
};
</script>
